module.exports = __webpack_public_path__ + "static/media/9-AirHeatExchanger - Water cool - Water heat.8053a7b9.png";